import StateOfHiringComponent from 'components/marketingSite/stateOfHiring/StateOfHiringComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type StateOfHiringPageProps = {
  baseUrl?: string;
};

const StateOfHiringPage: React.FC<StateOfHiringPageProps> = ({ baseUrl }) => {
  const { t } = useI18n('state-of-hiring');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        indexable
        title={t('state-of-hiring.page_title')}
        url={APP_URLS.stateOfHiring}
        desc={t('state-of-hiring.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_state_of_hiring.png'
        )}`}
      />
      <StateOfHiringComponent />
    </>
  );
};

export default StateOfHiringPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'state-of-hiring'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
